'use strict'

/*
 * Module permettant la d'afficher un élémeny HTML
 * La "bouton" servant pour l'affichage doivent avoir
 * la classe j_showHide_item. et avoir l'attribut data-target
 * avec le selecteur de l'élément HTML à afficher.
 * Les éléments à afficher et cacher doivent avoir la classe j_showHide_target
 */

/** * DEBUT : VARIABLES COMMUNES AUX INSTANCES ***/
const J_ITEM_SELECTOR = '.j_showHide_item'
const J_TARGET = '.j_showHide_target'
const J_ITEM_TARGET_DATA = 'target'
const C_HIDDEN = 'hidden'

export default function (selectedItemClass, unselectectItemsClass, idShowHide) {
    /** * DEBUT : VARIABLES PRIVEES ***/
    const selectors = {
        itemSelector: J_ITEM_SELECTOR,
        targetSelector: J_TARGET,
        selectedItemClass: '',
        unselectectItemsClass: ''
    }
    const $selectedItem = null
    const $selectedTarget = null
    /** * FIN : VARIABLES PRIVEES ***/

    /** * DEBUT : INITIALISATION ***/
    if (selectedItemClass) {
        selectors.selectedItemClass = selectedItemClass
    }

    if (unselectectItemsClass) {
        selectors.unselectectItemsClass = unselectectItemsClass
    }

    if (idShowHide) {
        selectors.itemSelector = J_ITEM_SELECTOR + idShowHide
        selectors.targetSelector = J_TARGET + idShowHide
    }
    /** * FIN : INITIALISATION ***/

    /** * DEBUT : FONCTIONS PRIVEES ***/

    /*
     * Permet d'associer l'événement click à tous les items
     * optionnel :
     * - selectedClass et unselectectItemsClass
     *      Permet de définir les classes à ajouter aux items séléctionné et non sélectionné
     * - idShowHide.
     *      A utiliser dans le cas ou plusieurs showHide sont utilisés sur une même page.
     *      Dans ce cas il faut suffuxié toute les classes par cette id dans le html
     *      (ex j_showHide_Item1, j_showHide_Target1 si id = 1)
     */
    function setEvents() {
        $(selectors.itemSelector).on('click', function (event) {
            switchShowHide(event.currentTarget)
        })
    }

    /*
     * Affiche le target associé à l'item et cache les autre éléments
     */
    function switchShowHide(item) {
        // On récupère l'item à afficher spécifié dans le paramètre "data-target"
        const target = $(item).data(J_ITEM_TARGET_DATA)

        if (!target) {
            return
        }

        // On cache toutes les targets associé à ce showHide
        $(selectors.targetSelector).addClass(C_HIDDEN)
        // On affiche la current target
        $(target).removeClass(C_HIDDEN)

        // Remise à zero
        // On enleve toutes les classes selected et unselected
        if (selectors.unselectectItemsClass) {
            $(selectors.itemSelector).removeClass(
                selectors.unselectectItemsClass
            )
        }
        if (selectors.selectedItemClass) {
            $(selectors.itemSelector).removeClass(selectors.selectedItemClass)
        }

        // On ajoute la classe unselected à tout le monde
        if (selectors.unselectectItemsClass) {
            $(self.itemSelector).addClass(selectors.unselectectItemsClass)
        }

        // On enleva le classe unselected et on ajoute la classe selected à l'item qui à levé l'événement (donc celui séléctionné)
        if (selectors.unselectectItemsClass) {
            $(item).removeClass(selectors.unselectectItemsClass)
        }
        if (selectors.selectedItemClass) {
            $(item).addClass(selectors.selectedItemClass)
        }

        selectors.$selectedItem = $(item)
        selectors.$selectedTarget = $(target)

        return false
    }
    /** * FIN : FONCTIONS PRIVEES ***/

    /** * DEBUT : PROPRIETES PUBLIC ***/
    this.setEvents = setEvents
    this.$selectedItem = $selectedItem
    this.$selectedTarget = $selectedTarget
    /** * FIN : PROPRIETES PUBLIC ***/
}
